import React, { useState } from "react"
import { View } from "react-native"
import { Divider, List } from "react-native-paper"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"
import { ProgramContentToValidate, activities } from "./DiagnosticConclusionLogic"
import styles from "./styles"
import ConclusionWorkshops from "./ConclusionWorkshops"

const DiagnosticConclusionProgram = ({ conclusion, isPatientFiche }) => {
    return (
        <View style={styles.container}>
            <OpenSansText
                style={{ textAlign: "center" }}
                color={baseColors.orange.primary}
                fontWeight="bold"
                fontSize={16}
            >
                DÉTAIL DU PROGRAMME {`${!isPatientFiche ? "À VALIDER" : ""}`} :
            </OpenSansText>

            <View style={styles.content}>
                {ProgramContentToValidate(conclusion).map((item, index) => {
                    if (item?.isWorkshops) {
                        return (
                            <View key={index}>
                                <ConclusionWorkshops title={item?.title} workshops={item?.workshops ?? []} />
                                <Divider style={styles.divider} />
                            </View>
                        )
                    }
                    return (
                        <View key={index}>
                            <ConclusionWorkshops isPost title={item?.title} workshops={item?.articles} />
                            <Divider style={styles.divider} />
                        </View>
                    )
                })}
            </View>

            <Spacer height={20} />
        </View>
    )
}

export default DiagnosticConclusionProgram
